import { SIDEBAR_ICON_SIZE } from "@/constants/UiConstants"
import { IconProps } from "@tabler/icons-react"
import { LucideIcon } from "lucide-react"
import { forwardRef } from "react"
import { SidebarMenuButton, SidebarMenuItem } from "../ui/sidebar"

interface SidebarFooterOptionProps {
  id?: string
  title: string
  icon: React.ComponentType<IconProps> | LucideIcon
  description?: string
  showDot?: boolean
  rightElement?: React.ReactElement
  onClick?: () => void
  className?: string
}

const SidebarFooterOption = forwardRef<
  HTMLButtonElement,
  SidebarFooterOptionProps
>(({ id, title, onClick, icon, showDot, rightElement }, ref) => {
  const Icon = icon

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        id={id}
        ref={ref}
        onClick={onClick}
        tooltip={{
          children: title,
          side: "right",
          align: "center",
          className:
            "bg-secondary-foreground text-card shadow-md border border-muted-foreground",
        }}
      >
        <div className="relative">
          <Icon
            style={{
              height: SIDEBAR_ICON_SIZE,
              width: SIDEBAR_ICON_SIZE,
            }}
          />
          {showDot ? (
            <span
              aria-hidden="true"
              className="absolute bottom-0 right-0 h-2 w-2 rounded-full bg-primary"
            />
          ) : null}
        </div>

        <span className="truncate">{title}</span>

        {rightElement}
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
})

SidebarFooterOption.displayName = "SidebarFooterOption"

export { SidebarFooterOption }
